import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { getCustomerPushCartApi, updateQuoteCustomerDataApi } from 'api';
import { setQuoteCustomerData } from 'redux/actions/quote';
import UpdatePhoneNumberModal from './UpdatePhoneNumberModal';


const SelectPatientButton = ({ customer, handleCloseModal }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isUpdatePhoneNumberModalOpen, setUpdatePhoneNumberModalOpen] = useState(false);

  const isPhoneNumberAbsent = !customer.custom_attributes?.find(
    (attr) => attr.attribute_code === 'phone_number'
  )?.value;

  const handleSelectPatient = async () => {
    if (isPhoneNumberAbsent) {
      setUpdatePhoneNumberModalOpen(true);
    } else {
      dispatch(setQuoteCustomerData(customer));

      await getCustomerPushCartApi({
        dispatch,
        customerId: customer.id,
      });

      history.push(`/quoting/profile/${customer.id}`);

      handleCloseModal();
    }
  };

  const handleUpdatePhoneNumber = async (newPhoneNumber) => {
    const updatedCustomer = {
      ...customer,
      custom_attributes: [
        ...(customer?.custom_attributes || []),
        {
          attribute_code: 'phone_number',
          value: newPhoneNumber.telephone,
        },
      ],
    };

    const isAccountCreated = await updateQuoteCustomerDataApi({ dispatch, customerId: customer.id, customerData: updatedCustomer });

    if (isAccountCreated) {
      setUpdatePhoneNumberModalOpen(false);
    }
  };

  return (
    <>
      <Button
        color="primary"
        variant="contained"
        className="uppercase text-12 mr-2 whitespace-no-wrap px-2"
        onClick={handleSelectPatient}
      >
        Select
      </Button>

      {isUpdatePhoneNumberModalOpen && (
        <UpdatePhoneNumberModal
          onUpdatePhoneNumber={handleUpdatePhoneNumber}
          setOpen={setUpdatePhoneNumberModalOpen}
          open={isUpdatePhoneNumberModalOpen}
        />
      )}
    </>
  );
};

export default SelectPatientButton;
